var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasData)?_c('div',{staticClass:"ct-chart-data-summary-doughnut"},[_c('div',{staticClass:"ct-chart-data-summary-doughnut__container"},[_c('div',{staticClass:"ct-chart-data-summary-doughnut__chart-container"},[_c('canvas',{ref:"chartCanvas"})])]),_vm._v(" "),_c(_setup.LegendDataSummary,_vm._b({},'LegendDataSummary',{
        legends: _vm.topXList,
        translations: _vm.translations
    },false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }